import React from "react";

const Sixth_Answer = () => {
  return (
    <>
      <div className="sixth_answer">
        <p>
          The award winners will be sent a confirmation letter four weeks prior
          to the awards ceremony and would be given an option to attend the
          ceremony depending on their availability. As the most prominent awards
          in India, please make sure that you do not miss out on this
          opportunity to emphasise at your brand image on the ceremony!
        </p>
      </div>
    </>
  );
};

export default Sixth_Answer;
